import Http from "../services/http.ts";

const protocolName=Http;
let endpoint="";
let method="";
let idRequired=false;
let idAndPayloadBothRequired=false;
/**
 * WARNING :- Don't change this file content else there will be an big blast💀, Block User and User update api route has not been deleted due to some routing issues else all routes has been commented
 * @param data - payload object
 * @param endPoint - api endpoint
 * @param methodName - defines that which api should be called
 * @param idrequired - whether id is required in params or not
 * @param idandpayloadbothrequired - whether param id and payload both required or not
 * @returns
 */
export const apiCall = (data,endPoint,methodName,idrequired,params,idandpayloadbothrequired) => {
    try{
        endpoint=endPoint
        method=methodName
        idRequired=idrequired
        idAndPayloadBothRequired=idandpayloadbothrequired
        if(idRequired===true && idAndPayloadBothRequired===true){
            return protocolName[method](`${endpoint}${data?.id}`,data)
        } else if(idRequired===true && idAndPayloadBothRequired===false){
            const paramToPass=data?.id || data?.clientId
            if(paramToPass){
                return protocolName[method](`${endpoint}${paramToPass}`)
            }else{
                return protocolName[method](`${endpoint}`)
            }
        } else{
            const dataToPass =  data
            return protocolName[method](endpoint,dataToPass)
        }
    }catch(error){
        console.error('error: ', params);
    }
};
